import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle, Loader } from 'lucide-react';
import { verifyEmail } from '../api/authAPI';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './AuthPages.css';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const token = searchParams.get('token');

  useEffect(() => {
    if (token) {
      handleVerify();
    } else {
      setStatus('error');
      setMessage('Invalid verification link.');
    }
  }, [token]);

  const handleVerify = async () => {
    try {
      const response = await verifyEmail(token);
      if (response.success) {
        setStatus('success');
        setMessage(response.message);
      } else {
        setStatus('error');
        setMessage(response.message);
      }
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.message || 'Verification failed.');
    }
  };

  return (
    <>
      <Navbar />
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-header">
            {status === 'loading' && (
              <>
                <div className="verify-icon">
                  <Loader size={32} className="spin" />
                </div>
                <h1>Verifying your email...</h1>
                <p className="verify-message">Please wait a moment.</p>
              </>
            )}
            {status === 'success' && (
              <>
                <div className="verify-icon success-icon">
                  <CheckCircle size={32} />
                </div>
                <h1>Email Verified!</h1>
                <p className="verify-message">{message}</p>
                <Link to="/login" className="auth-submit-btn"
                  style={{ display: 'block', textAlign: 'center', marginTop: 24 }}>
                  Login to your account
                </Link>
              </>
            )}
            {status === 'error' && (
              <>
                <div className="verify-icon error-icon">
                  <XCircle size={32} />
                </div>
                <h1>Verification Failed</h1>
                <p className="verify-message">{message}</p>
                <Link to="/register" className="auth-submit-btn"
                  style={{ display: 'block', textAlign: 'center', marginTop: 24 }}>
                  Register again
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default VerifyEmailPage;